import { useFeatureFlag } from 'featureFlags';

import { MAX_RUNS } from './multiRunPhase';

/**
 * The highest run count an initiator may offer right now (EN-10921).
 *
 * Normally MAX_RUNS (3). The operational switch `ops.multi-run-withhold-3x`
 * takes 3X off the offer without a release: the lever for Ryan's one-month
 * review, and flipping it back restores 3X the same way. It is read through the
 * flag registry like every client flag; with the SDK unavailable it reads off,
 * which is today's behaviour.
 */
export const useMaxRunCount = (): number => (useFeatureFlag('multiRunWithhold3x') ? 2 : MAX_RUNS);
